var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Close side panel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#737373",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 46,
    width: 186,
    height: 164,
    rx: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 47V209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 97L127 128L158 159"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClose);
export default __webpack_public_path__ + "static/media/sidebar-close.d23b88faaedc6eb0e9bd3740f62427bc.svg";
export { ForwardRef as ReactComponent };